import React, { useState, useRef } from 'react'

import { Box, Button, Grid } from '@material-ui/core'
import {
  HelpCircle as HelpCircleIcon,
  PlusCircle as PlusCircleIcon,
} from 'react-feather'
import { useHistory } from 'react-router-dom'

import {
  Container,
  ContentHeader,
  DriveTour,
  Page,
  Permitted,
} from 'components'
import { Filters, MySuppliersTable, ProgressStatsCards } from '../components'

import useFilter from 'hooks/useFilter'

import { routes } from 'Routes'
import constants from 'constants/index'
import permissions from 'constants/permissions'
import theme from 'theme'

const ThirdPartyManagementPreAvaliation = () => {
  const [openTour, setOpenTour] = useState(false)
  const statsCardsRef = useRef(null)

  const filter = useFilter()
  const history = useHistory()

  const { STEPS, STEPS_OBJECT } = constants.tours.thirdPartyManagements

  const handleOpenTour = () => setOpenTour(true)

  const handleRedirectToCreate = () =>
    history.push({
      pathname: routes.thirdPartyManagements.mySuppliers.new,
      search: `?preAvaliation=true`,
    })

  const handleRefreshStats = () => statsCardsRef.current?.refresh()

  return (
    <Page title="Gestão de Fornecedores - Pré-Avaliação">
      <Container maxWidth={false}>
        <ContentHeader title="Pré-Avaliação">
          <Button
            id={STEPS.PRE_AVALIATION.DEFAULT[1]}
            variant="contained"
            color="primary"
            startIcon={<HelpCircleIcon size={20} />}
            onClick={handleOpenTour}
          >
            Tutorial
          </Button>

          <Permitted tag={permissions.COMPANY_SUPPLIERS.UPDATE}>
            <Button
              id={STEPS.PRE_AVALIATION.DEFAULT[2]}
              variant="contained"
              color="primary"
              startIcon={<PlusCircleIcon size={20} />}
              onClick={handleRedirectToCreate}
            >
              Criar
            </Button>
          </Permitted>

          <Filters filter={filter} />
        </ContentHeader>

        <Box display="flex" flexDirection="column" gridGap={theme.spacing(2)}>
          <ProgressStatsCards
            ref={statsCardsRef}
            filter={filter}
            preAvaliation
          />

          <Grid container spacing={3}>
            <Grid item xs={12}>
              <MySuppliersTable
                filter={filter}
                preAvaliation
                onRefreshStats={handleRefreshStats}
              />
            </Grid>
          </Grid>
        </Box>
      </Container>

      <DriveTour
        stepsMatrix={STEPS_OBJECT.PRE_AVALIATION.DEFAULT}
        open={openTour}
        setOpen={setOpenTour}
      />
    </Page>
  )
}

export default ThirdPartyManagementPreAvaliation
